module.exports = __webpack_public_path__ + "img/user-blue.8bf93381.png";